import { getPubAbbr } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function BrandingNameRenderer({ value }) {
    const name = value.split("@")[0];
    let views = value.split("@")[1];
    const inventory_type = value.split("@")[2];
    const forecasting = value.split("@")[3];

    // Check if forecasting is enabled (handle boolean, string, null, undefined)
    // Show views badge when forecasting is enabled (true or 'true'), hide otherwise
    const isForecastingDisabled = forecasting === 'false' || forecasting === false || forecasting === 'null' || forecasting === null || forecasting === undefined || forecasting === 'undefined';
    const isForecastingEnabled = !isForecastingDisabled;

    let type = ''

    if (inventory_type == 1) {
        type = 'DEPARTMENT'
    } else if (inventory_type == 3) {
        type = 'HOMEPAGE'
    } else if (inventory_type == 4) {
        type = 'BANNER'
    } else if (inventory_type == 5) {
        type = 'CLUSTER'
    } else if (inventory_type == 34) {
        type = 'SPOTLIGHT'
    } else if (inventory_type == 7) {
        type = 'FEATURED CONTENT'
    }

    if (views.includes(',')) {
        views = views.split(',')[0] + views.split(',')[1].slice(0, 1) + 'k';
    }

    return (
        <div className='flex-column'>
            <div className="d-flex align-items-center table-item-name" style={{ lineHeight: '14px', marginTop: '5px', marginBottom: '5px' }}>
                {name}
                {isForecastingEnabled && (
                    <div
                        className='badge bg-outline-secondary ms-2'
                        // title={`Current invetory recived ${visits} visits per last 30 days`}
                    >
                        {views} Views
                    </div>
                )}
            </div>
            <div
                className="d-flex align-items-center text-secondary"
                style={{ fontSize: '12px', marginTop: '-15px' }}
            >
                <span className='fw-bold'>{type}</span>
            </div>
            {/* <div className="align-items-center" style={{ fontSize: '12px', lineHeight: '12px' }}>
                <div className='badge bg-outline-secondary badg'>{type}</div>
            </div> */}
        </div>
    );
}

export function BrandingNameColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    let tooltip = taxonomy.tooltips.ppc_branding_column_headers.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}

export function BrandingNameCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    
    const name = value.split("@")[0];
    const visits = value.split("@")[1];

    let tooltip = taxonomy.tooltips.ppc_branding_column_inlines.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}
 